import React from 'react'
import { Routes, Route } from "react-router-dom";
import Login from '../pages/Authentication/Login';
import Signup from '../pages/Authentication/Signup';
import OtpVerification from '../pages/Authentication/OtpVerification';
// import UpdatePassword from '../pages/Authentication/UpdatePassword';
function UnAuthenticatedRoutes() {
  return (
    <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/signup" element={<Signup/>}/>
        <Route path="/otp-verification" element={<OtpVerification/>}/>
        {/* <Route path="/update-password/:token" element={<UpdatePassword/>}/> */}
    </Routes>
  )
}

export default UnAuthenticatedRoutes